<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="520px"
       height="422px" viewBox="-0.5 -0.5 496 422"
       content="&lt;mxfile host=&quot;app.diagrams.net&quot; modified=&quot;2020-04-10T19:15:08.428Z&quot; agent=&quot;5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/80.0.3987.163 Safari/537.36&quot; etag=&quot;l6h988b3rfuT_W1S753v&quot; version=&quot;12.9.10&quot; type=&quot;google&quot;&gt;&lt;diagram id=&quot;z64VrUtyoGxnSVvjjgbu&quot; name=&quot;Page-1&quot;&gt;7Vzbcuo2FP0aHpuxJF/gEQhpz0xOk5mcmTbnTcUC3BqLGhGgX1/ZlvFFcjDGFzI4ZDJoW5bwXmtLey/sDNB0ffjVx5vVd2oTdwA1+zBAjwMIgQ7hIPjV7GNksQCKDEvfsUWnxPDm/EeEURPWnWOTbaYjo9RlziZrnFPPI3OWsWHfp/tstwV1s7Nu8JJIhrc5dmXrH47NVpEVIjRKDvxGnOVKTI2QJj75Gse9hWG7wjbdp0xoNkBTn1IWvVsfpsQNvBc7JjrvqeDo6ZP5xGNlTvjrff9Tez1sncXTEU7cf5fLZ/aLbkbDfGB3Jy5ZfFp2jH1APHscuJK3POpx42TF1i5vAf52y3z6D5lSl/phbzQLX6cjsdcMbolGJrbk8uQSwMkxnFKErgnzj7zLPvG9Idy5Snk9tvnExcz5yA6PBQWWp+FOM7xSh08MtUOWdIKryNAfLDM7yJbu/DkR56WdnRvK0M6PxbC/JEwai79JXXtiCuG8AFoEz0Pr051nk2AUjeOzXzmMvG3wPDi65wGdhXrhuG4MtCDCgnpMBC0Aop3igmEEsNt4uwrnAKLxihkjvhdaoAYkrkAVrybh68SiD+IzcriUR4c4SkcPRgYfqAu8UkwDUIt7pckGhloxsTIgXoyY3iNWhBg8D5dptQzXsIerAC5omfkAUwBmoJYBK7HZ3SlgpnYWLajYeJvDSgd9YlKUmABk1JOVSAM1nJIAIGPInf4mmtRnK7qkHnZniXWSjcikzzOlG4H134Sxo4g6vGM0ywRycNifwekPhmi9p448HsTIYeMoGsXBJgdmJpo5Yfxjarag+R7PEDSS+cJWPGFZCnLnhWB/5uWoX4TlJ/1MNaUv4yoPQHxMddgE3Nk2Qp4SC4Lr8sKQXLZwc3DNuWVYtgS7WFRqWF4BgLn90JRXWKRYQFBT66tcHDxihrllijds52PJt/zi2WcrbLz/yVsidp1lsLXNubMIt08CVzq8xh6LA2vHtt0i1LLhr9xOawBolMcHyfgMFfjAxnKVL8x2ZOazv67ZLhdWd812pIMbo3sZGaoi3RcgeLW6uANF/twq360ivtM59f3BFA3G47lzb7Qf5rJfxao0UhSkjZG+hH5ws6RH2o1RftRTXinESGtT16yPi9nKlX1SYmUKrKTeKiix4jowrvxSZ5WvA4ExeTL1q1SEEiWc2A7PlnBDNfjtqBL8J8+tvBxUVphQ0DS/UDQtTShI2KI0cQ0lv5A0ga7j9bUyGrDyLNMqElY3JcLq5QhbLJioZ0Iwm7VYRo7+0YD1BoP+VYKhKqcrB1GNwQCMktEARnWEw6XEs/LBEqcJzVLPKJEd3KrwAVB+VTjVHF2lxUCurO9a+pCL9VM61JX2AeRq/etQHg2lb3o7p7xcV9815ZGZV/u6p7xcrddG+calDyn1Q4q7Udr9MkcuqXvxI/F3DJNiYWpV+Yiv4EuyPljo9VHyM0Q3FgOwjwEVbIZ+Y0FQ5pvNO5f/4u3xbGXY7W1JUM/vhHpVPUXxBbzRrgAIO9E8WhfzqtwMVSezrSuZfSVldS23bYGqAuBQIqx5rQBYO6XlQujH7PvrCzc9zoJy6OX36bfnb+Ngbxxa4V/0csP7Y/6+2jg247TqKl3AyiWLijsigGG1uVHKNVKPXhF6+jCDHgBdo4fkNOeHj70tDhPREK4xogGWDUDmkgW7DrASd6inMS3MYOsG+vTgXaxkqO5UB21KGUgWrNVAT3ugr3jgp3ucZZVWjfO4x7nCgyfd4arYZpW4Tnpcqz0B1hm0uiwJMbLe0BtNki6DctSgaKTnHgdT3dynK5DMF1P1ISkvvj2SVZBUybQ1IcmbyT8ziErY5H9CoNn/&lt;/diagram&gt;&lt;/mxfile&gt;"
       style="background-color: rgb(255, 255, 255);">
    <defs/>
    <g>
      <path d="M 2 354.76 L 492 354.76" fill="none" stroke="#e3e3e3" stroke-width="5" stroke-miterlimit="10"
            pointer-events="stroke"/>
      <rect x="331.5" y="240" width="120.5" height="180" fill="none" stroke="#b3b3b3" stroke-width="2"
            stroke-dasharray="2 2" pointer-events="all"/>
      <rect x="24" y="240" width="167.5" height="180" fill="none" stroke="#b3b3b3" stroke-width="2"
            stroke-dasharray="2 2" pointer-events="all"/>
      <rect x="268.5" y="20" width="153.5" height="180" fill="none" stroke="#b3b3b3" stroke-width="2"
            stroke-dasharray="2 2" pointer-events="all"/>
      <rect x="52" y="20" width="120" height="180" fill="none" stroke="#b3b3b3" stroke-width="2" stroke-dasharray="2 2"
            pointer-events="all"/>
      <path d="M 2 135 L 492 135" fill="none" stroke="#e3e3e3" stroke-width="5" stroke-miterlimit="10"
            pointer-events="stroke"/>
      <path d="M 119.5 90 L 119.5 111.76" fill="none" stroke="#b3b3b3" stroke-width="2" stroke-miterlimit="10"
            stroke-dasharray="6 6" pointer-events="stroke"/>
      <path d="M 119.5 117.76 L 115.5 109.76 L 119.5 111.76 L 123.5 109.76 Z" fill="#b3b3b3" stroke="#b3b3b3"
            stroke-width="2" stroke-miterlimit="10" pointer-events="all"/>
      <ellipse cx="119.5" cy="75" rx="15" ry="15" fill="#6c757d" stroke="none" pointer-events="all"/>
      <rect x="84.5" y="30" width="80" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g transform="translate(-0.5 -0.5)">
        <switch>
          <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%"
                         requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
            <div xmlns="http://www.w3.org/1999/xhtml"
                 style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 78px; height: 1px; padding-top: 40px; margin-left: 86px;">
              <div style="box-sizing: border-box; font-size: 0; text-align: center; ">
                <div
                  style="display: inline-block; font-size: 12px; font-family: Helvetica; color: #555; line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; ">
                  Data Captura
                </div>
              </div>
            </div>
          </foreignObject>
          <text x="125" y="44" fill="#555" font-family="Helvetica" font-size="12px" text-anchor="middle">Data Captura
          </text>
        </switch>
      </g>
      <ellipse cx="373.5" cy="75" rx="15" ry="15" fill="#6c757d" stroke="none" pointer-events="all"/>
      <rect x="333.5" y="30" width="80" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g transform="translate(-0.5 -0.5)">
        <switch>
          <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%"
                         requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
            <div xmlns="http://www.w3.org/1999/xhtml"
                 style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 78px; height: 1px; padding-top: 40px; margin-left: 335px;">
              <div style="box-sizing: border-box; font-size: 0; text-align: center; ">
                <div
                  style="display: inline-block; font-size: 12px; font-family: Helvetica; color: #555; line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; ">
                  Data Captura
                </div>
              </div>
            </div>
          </foreignObject>
          <text x="374" y="44" fill="#555" font-family="Helvetica" font-size="12px" text-anchor="middle">Data Captura
          </text>
        </switch>
      </g>
      <ellipse cx="119.5" cy="135" rx="15" ry="15" fill="#f1f1f1" stroke="none" pointer-events="all"/>
      <rect x="72" y="160" width="95" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g transform="translate(-0.5 -0.5)">
        <switch>
          <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%"
                         requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
            <div xmlns="http://www.w3.org/1999/xhtml"
                 style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 93px; height: 1px; padding-top: 170px; margin-left: 73px;">
              <div style="box-sizing: border-box; font-size: 0; text-align: center; ">
                <div
                  style="display: inline-block; font-size: 12px; font-family: Helvetica; color: #555; line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; ">
                  Data ocorrêcia
                </div>
              </div>
            </div>
          </foreignObject>
          <text x="120" y="174" fill="#555" font-family="Helvetica" font-size="12px" text-anchor="middle">Data
            ocorrêcia
          </text>
        </switch>
      </g>
      <ellipse cx="312" cy="135" rx="15" ry="15" fill="#f1f1f1" stroke="none" pointer-events="all"/>
      <rect x="264.5" y="160" width="95" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g transform="translate(-0.5 -0.5)">
        <switch>
          <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%"
                         requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
            <div xmlns="http://www.w3.org/1999/xhtml"
                 style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 93px; height: 1px; padding-top: 170px; margin-left: 266px;">
              <div style="box-sizing: border-box; font-size: 0; text-align: center; ">
                <div
                  style="display: inline-block; font-size: 12px; font-family: Helvetica; color: #555; line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; ">
                  Data ocorrêcia
                </div>
              </div>
            </div>
          </foreignObject>
          <text x="312" y="174" fill="#555" font-family="Helvetica" font-size="12px" text-anchor="middle">Data
            ocorrêcia
          </text>
        </switch>
      </g>
      <path d="M 134.5 135 L 297 135" fill="none" stroke="#15bf64" stroke-width="5" stroke-miterlimit="10"
            pointer-events="stroke"/>
      <path d="M 358.5 75 L 312 75 L 312 111.76" fill="none" stroke="#b3b3b3" stroke-width="2" stroke-miterlimit="10"
            stroke-dasharray="6 6" pointer-events="stroke"/>
      <path d="M 312 117.76 L 308 109.76 L 312 111.76 L 316 109.76 Z" fill="#b3b3b3" stroke="#b3b3b3" stroke-width="2"
            stroke-miterlimit="10" pointer-events="all"/>
      <path d="M 124.5 295 L 69.5 295 L 69.5 331.76" fill="none" stroke="#b3b3b3" stroke-width="2"
            stroke-miterlimit="10" stroke-dasharray="6 6" pointer-events="stroke"/>
      <path d="M 69.5 337.76 L 65.5 329.76 L 69.5 331.76 L 73.5 329.76 Z" fill="#b3b3b3" stroke="#b3b3b3"
            stroke-width="2" stroke-miterlimit="10" pointer-events="all"/>
      <ellipse cx="139.5" cy="295" rx="15" ry="15" fill="#6c757d" stroke="none" pointer-events="all"/>
      <rect x="104.5" y="250" width="80" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g transform="translate(-0.5 -0.5)">
        <switch>
          <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%"
                         requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
            <div xmlns="http://www.w3.org/1999/xhtml"
                 style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 78px; height: 1px; padding-top: 260px; margin-left: 106px;">
              <div style="box-sizing: border-box; font-size: 0; text-align: center; ">
                <div
                  style="display: inline-block; font-size: 12px; font-family: Helvetica; color: #555; line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; ">
                  Data Captura
                </div>
              </div>
            </div>
          </foreignObject>
          <text x="145" y="264" fill="#555" font-family="Helvetica" font-size="12px" text-anchor="middle">Data Captura
          </text>
        </switch>
      </g>
      <ellipse cx="393.5" cy="295" rx="15" ry="15" fill="#6c757d" stroke="none" pointer-events="all"/>
      <rect x="353.5" y="250" width="80" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g transform="translate(-0.5 -0.5)">
        <switch>
          <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%"
                         requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
            <div xmlns="http://www.w3.org/1999/xhtml"
                 style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 78px; height: 1px; padding-top: 260px; margin-left: 355px;">
              <div style="box-sizing: border-box; font-size: 0; text-align: center; ">
                <div
                  style="display: inline-block; font-size: 12px; font-family: Helvetica; color: #555; line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; ">
                  Data Captura
                </div>
              </div>
            </div>
          </foreignObject>
          <text x="394" y="264" fill="#555" font-family="Helvetica" font-size="12px" text-anchor="middle">Data Captura
          </text>
        </switch>
      </g>
      <ellipse cx="69.5" cy="355" rx="15" ry="15" fill="#f1f1f1" stroke="none" pointer-events="all"/>
      <rect x="22" y="380" width="95" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g transform="translate(-0.5 -0.5)">
        <switch>
          <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%"
                         requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
            <div xmlns="http://www.w3.org/1999/xhtml"
                 style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 93px; height: 1px; padding-top: 390px; margin-left: 23px;">
              <div style="box-sizing: border-box; font-size: 0; text-align: center; ">
                <div
                  style="display: inline-block; font-size: 12px; font-family: Helvetica; color: #555; line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; ">
                  Data ocorrêcia
                </div>
              </div>
            </div>
          </foreignObject>
          <text x="70" y="394" fill="#555" font-family="Helvetica" font-size="12px" text-anchor="middle">Data
            ocorrêcia
          </text>
        </switch>
      </g>
      <ellipse cx="393.5" cy="355" rx="15" ry="15" fill="#f1f1f1" stroke="none" pointer-events="all"/>
      <rect x="346" y="380" width="95" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g transform="translate(-0.5 -0.5)">
        <switch>
          <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%"
                         requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
            <div xmlns="http://www.w3.org/1999/xhtml"
                 style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 93px; height: 1px; padding-top: 390px; margin-left: 347px;">
              <div style="box-sizing: border-box; font-size: 0; text-align: center; ">
                <div
                  style="display: inline-block; font-size: 12px; font-family: Helvetica; color: #555; line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; ">
                  Data ocorrêcia
                </div>
              </div>
            </div>
          </foreignObject>
          <text x="394" y="394" fill="#555" font-family="Helvetica" font-size="12px" text-anchor="middle">Data
            ocorrêcia
          </text>
        </switch>
      </g>
      <path d="M 84.5 355 L 378.5 355" fill="none" stroke="#15bf64" stroke-width="5" stroke-miterlimit="10"
            pointer-events="stroke"/>
      <path d="M 393.5 310 L 393.5 331.76" fill="none" stroke="#b3b3b3" stroke-width="2" stroke-miterlimit="10"
            stroke-dasharray="6 6" pointer-events="stroke"/>
      <path d="M 393.5 337.76 L 389.5 329.76 L 393.5 331.76 L 397.5 329.76 Z" fill="#b3b3b3" stroke="#b3b3b3"
            stroke-width="2" stroke-miterlimit="10" pointer-events="all"/>
      <rect x="162" y="330" width="157" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g transform="translate(-0.5 -0.5)">
        <switch>
          <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%"
                         requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
            <div xmlns="http://www.w3.org/1999/xhtml"
                 style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 155px; height: 1px; padding-top: 340px; margin-left: 163px;">
              <div style="box-sizing: border-box; font-size: 0; text-align: center; ">
                <div
                  style="display: inline-block; font-size: 11px; font-family: Helvetica; color: #000000; line-height: 1.2; pointer-events: all; font-weight: bold; white-space: normal; word-wrap: normal; ">
                  TEMPO DE CONCILIAÇÃO
                </div>
              </div>
            </div>
          </foreignObject>
          <text x="241" y="343" fill="#000000" font-family="Helvetica" font-size="11px" text-anchor="middle"
                font-weight="bold">TEMPO DE CONCILIAÇÃO
          </text>
        </switch>
      </g>
      <rect x="140" y="110" width="157" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g transform="translate(-0.5 -0.5)">
        <switch>
          <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%"
                         requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
            <div xmlns="http://www.w3.org/1999/xhtml"
                 style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 155px; height: 1px; padding-top: 120px; margin-left: 141px;">
              <div style="box-sizing: border-box; font-size: 0; text-align: center; ">
                <div
                  style="display: inline-block; font-size: 11px; font-family: Helvetica; color: #000000; line-height: 1.2; pointer-events: all; font-weight: bold; white-space: normal; word-wrap: normal; ">
                  TEMPO DE CONCILIAÇÃO
                </div>
              </div>
            </div>
          </foreignObject>
          <text x="219" y="123" fill="#000000" font-family="Helvetica" font-size="11px" text-anchor="middle"
                font-weight="bold">TEMPO DE CONCILIAÇÃO
          </text>
        </switch>
      </g>
      <rect x="331" y="220" width="110" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g transform="translate(-0.5 -0.5)">
        <switch>
          <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%"
                         requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
            <div xmlns="http://www.w3.org/1999/xhtml"
                 style="display: flex; align-items: unsafe center; justify-content: unsafe flex-start; width: 108px; height: 1px; padding-top: 230px; margin-left: 333px;">
              <div style="box-sizing: border-box; font-size: 0; text-align: left; ">
                <div
                  style="display: inline-block; font-size: 10px; font-family: Helvetica; color: #555; line-height: 1.2; pointer-events: all; font-weight: bold; white-space: normal; word-wrap: normal; ">
                  Transação D
                </div>
              </div>
            </div>
          </foreignObject>
          <text x="333" y="233" fill="#555" font-family="Helvetica" font-size="10px" font-weight="bold">Transação D
          </text>
        </switch>
      </g>
      <rect x="24" y="220" width="110" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g transform="translate(-0.5 -0.5)">
        <switch>
          <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%"
                         requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
            <div xmlns="http://www.w3.org/1999/xhtml"
                 style="display: flex; align-items: unsafe center; justify-content: unsafe flex-start; width: 108px; height: 1px; padding-top: 230px; margin-left: 26px;">
              <div style="box-sizing: border-box; font-size: 0; text-align: left; ">
                <div
                  style="display: inline-block; font-size: 10px; font-family: Helvetica; color: #555; line-height: 1.2; pointer-events: all; font-weight: bold; white-space: normal; word-wrap: normal; ">
                  Transação C
                </div>
              </div>
            </div>
          </foreignObject>
          <text x="26" y="233" fill="#555" font-family="Helvetica" font-size="10px" font-weight="bold">Transação C
          </text>
        </switch>
      </g>
      <rect x="52" y="0" width="110" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g transform="translate(-0.5 -0.5)">
        <switch>
          <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%"
                         requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
            <div xmlns="http://www.w3.org/1999/xhtml"
                 style="display: flex; align-items: unsafe center; justify-content: unsafe flex-start; width: 108px; height: 1px; padding-top: 10px; margin-left: 54px;">
              <div style="box-sizing: border-box; font-size: 0; text-align: left; ">
                <div
                  style="display: inline-block; font-size: 10px; font-family: Helvetica; color: #555; line-height: 1.2; pointer-events: all; font-weight: bold; white-space: normal; word-wrap: normal; ">
                  Transação A
                </div>
              </div>
            </div>
          </foreignObject>
          <text x="54" y="13" fill="#555" font-family="Helvetica" font-size="10px" font-weight="bold">Transação A</text>
        </switch>
      </g>
      <rect x="268.5" y="0" width="110" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g transform="translate(-0.5 -0.5)">
        <switch>
          <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%"
                         requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
            <div xmlns="http://www.w3.org/1999/xhtml"
                 style="display: flex; align-items: unsafe center; justify-content: unsafe flex-start; width: 108px; height: 1px; padding-top: 10px; margin-left: 271px;">
              <div style="box-sizing: border-box; font-size: 0; text-align: left; ">
                <div
                  style="display: inline-block; font-size: 10px; font-family: Helvetica; color: #555; line-height: 1.2; pointer-events: all; font-weight: bold; white-space: normal; word-wrap: normal; ">
                  Transação B
                </div>
              </div>
            </div>
          </foreignObject>
          <text x="271" y="13" fill="#555" font-family="Helvetica" font-size="10px" font-weight="bold">Transação B
          </text>
        </switch>
      </g>
      <rect x="452" y="120" width="40" height="10" fill="none" stroke="none" pointer-events="all"/>
      <g transform="translate(-0.5 -0.5)">
        <switch>
          <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%"
                         requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
            <div xmlns="http://www.w3.org/1999/xhtml"
                 style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 38px; height: 1px; padding-top: 125px; margin-left: 453px;">
              <div style="box-sizing: border-box; font-size: 0; text-align: center; ">
                <div
                  style="display: inline-block; font-size: 9px; font-family: Helvetica; color: #555; line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; ">
                  tempo
                </div>
              </div>
            </div>
          </foreignObject>
          <text x="472" y="128" fill="#555" font-family="Helvetica" font-size="9px" text-anchor="middle">tempo</text>
        </switch>
      </g>
      <rect x="452" y="340" width="40" height="10" fill="none" stroke="none" pointer-events="all"/>
      <g transform="translate(-0.5 -0.5)">
        <switch>
          <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%"
                         requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
            <div xmlns="http://www.w3.org/1999/xhtml"
                 style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 38px; height: 1px; padding-top: 345px; margin-left: 453px;">
              <div style="box-sizing: border-box; font-size: 0; text-align: center; ">
                <div
                  style="display: inline-block; font-size: 9px; font-family: Helvetica; color: #555; line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; ">
                  tempo
                </div>
              </div>
            </div>
          </foreignObject>
          <text x="472" y="348" fill="#555" font-family="Helvetica" font-size="9px" text-anchor="middle">tempo</text>
        </switch>
      </g>
    </g>
    <switch>
      <g requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility"/>
      <a transform="translate(0,-5)" xlink:href="https://desk.draw.io/support/solutions/articles/16000042487"
         target="_blank">
        <text text-anchor="middle" font-size="10px" x="50%" y="100%">Viewer does not support full SVG 1.1</text>
      </a></switch>
  </svg>
</template>
<script>
export default {
  name: 'app-time-conciliated-info',
}
</script>
